import {
  ARTICLE_META,
  type ArticleMetaItem,
  type FreeArticleSlug,
} from "@/lib/articles/meta";

type FreeArticle = ArticleMetaItem & { slug: FreeArticleSlug };

export const FREE_ARTICLES = ARTICLE_META.filter(
  (item): item is FreeArticle => item.free === true
);

export const PREVIEW_ARTICLE_SLUGS = FREE_ARTICLES.map(
  (item) => item.slug
).toReversed();

const PREVIEW_ARTICLE_PATHS = new Set<string>(
  FREE_ARTICLES.map((item) => item.link)
);

export function isPreviewArticlePath(path: string): boolean {
  return PREVIEW_ARTICLE_PATHS.has(path);
}
